import { Button } from "@mui/material";
import { Download } from "@mui/icons-material";
import * as XLSX from "xlsx";

// Función para sanitizar nombres de archivos
const sanitizeFileName = (fileName) => {
  if (!fileName) return "Proyecto";

  return fileName
    .trim()
    .replace(/[áàäâ]/g, "a") // Reemplazar á, à, ä, â por a
    .replace(/[éèëê]/g, "e") // Reemplazar é, è, ë, ê por e
    .replace(/[íìïî]/g, "i") // Reemplazar í, ì, ï, î por i
    .replace(/[óòöô]/g, "o") // Reemplazar ó, ò, ö, ô por o
    .replace(/[úùüû]/g, "u") // Reemplazar ú, ù, ü, û por u
    .replace(/[ÁÀÄÂ]/g, "A") // Reemplazar Á, À, Ä, Â por A
    .replace(/[ÉÈËÊ]/g, "E") // Reemplazar É, È, Ë, Ê por E
    .replace(/[ÍÌÏÎ]/g, "I") // Reemplazar Í, Ì, Ï, Î por I
    .replace(/[ÓÒÖÔ]/g, "O") // Reemplazar Ó, Ò, Ö, Ô por O
    .replace(/[ÚÙÜÛ]/g, "U") // Reemplazar Ú, Ù, Ü, Û por U
    .replace(/ñ/g, "n") // Reemplazar ñ por n
    .replace(/Ñ/g, "N") // Reemplazar Ñ por N
    .replace(/[^\w\s-]/g, "") // Remover caracteres especiales excepto espacios, guiones y letras/números
    .replace(/\s+/g, "_") // Reemplazar espacios por guiones bajos
    .replace(/_{2,}/g, "_") // Reemplazar múltiples guiones bajos por uno solo
    .replace(/^_|_$/g, ""); // Remover guiones bajos al inicio o final
};

const InvestmentsExcelDownload = ({ investments, project }) => {
  const handleDownload = () => {
    // Preparar datos para Excel
    const excelData = investments.map((inv) => ({
      "ID Inversión (NO EDITAR)": inv._id,
      "Asociado (NO EDITAR)": inv.associateRef?.name || "",
      "Nombre Inversión": inv.investor || "",
      Vehículo: inv.vehiculo || "",
      Capital: inv.capital || 0,
      "Participación Global (%)": inv.participation || 0,
      "Participación IDE (%)": inv.participationIDE || 0,
    }));

    // Crear workbook y worksheet
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Inversiones");

    // Ajustar ancho de columnas
    const colWidths = [
      { wch: 20 }, // ID Inversión (NO EDITAR)
      { wch: 20 }, // Asociado (NO EDITAR)
      { wch: 20 }, // Nombre Inversión
      { wch: 20 }, // Vehículo
      { wch: 20 }, // Capital
      { wch: 15 }, // Participación Global
      { wch: 15 }, // Participación IDE
    ];
    worksheet["!cols"] = colWidths;

    // Nota: La protección de celdas en Excel requiere que el archivo sea guardado en formato .xlsx
    // y que Excel aplique la protección al abrir. Por compatibilidad, usamos solo indicadores visuales.
    // Los usuarios deben respetar las columnas marcadas como "(NO EDITAR)"

    // Generar archivo y descargarlo
    const timestamp = new Date().toISOString().slice(0, 10);
    const sanitizedProjectName = sanitizeFileName(project?.name);
    XLSX.writeFile(
      workbook,
      `${sanitizedProjectName}_inversiones_${timestamp}.xlsx`
    );
  };

  return (
    <Button
      variant="outlined"
      startIcon={<Download />}
      onClick={handleDownload}
    >
      Descargar Excel
    </Button>
  );
};

export default InvestmentsExcelDownload;
